import React from 'react';
import { useReveal } from '../../hooks/useReveal';

const Reveal = ({ children, className = '', as: Tag = 'div', ...rest }) => {
  const [ref, inView] = useReveal();
  return (
    <Tag
      ref={ref}
      className={`reveal${inView ? ' in' : ''} ${className}`.trim()}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
